import {
    FETCH_SERVICE_REQUEST_LIST,
    FETCH_JOB_ISSUE_TYPES,
    FETCH_JOB_SKILL_TYPES,
    FETCH_JOB_SKILL_LEVEL

} from '../actions/actionTypes';

const initialState = {
    issueTypes:          [],
    serviceRequests:     [],
    serviceRequestsMeta: {},
    skillLevel:          [],
    skillTypes:          []
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_SERVICE_REQUEST_LIST:
            return {
                ...state,
                serviceRequests:     [...action.payload.data],
                serviceRequestsMeta: {...action.payload.meta}
            };
        case FETCH_JOB_ISSUE_TYPES:
            return {
                ...state,
                issueTypes: [...action.payload.data]
            };
        case FETCH_JOB_SKILL_LEVEL:
            return {
                ...state,
                skillLevel: [...action.payload.data]
            };
        case FETCH_JOB_SKILL_TYPES:
            return {
                ...state,
                skillTypes: [...action.payload.data]
            };
        default:
            return state;
    }
};
